"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClientNotSupportedError = exports.AuthError = exports.APIError = void 0;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function ExtendableError(message) {
  this.name = this.constructor.name;
  this.message = message || 'Default Message';
  this.stack = new Error().stack;
}

ExtendableError.prototype = Object.create(Error.prototype);
ExtendableError.prototype.constructor = ExtendableError;

var APIError =
/*#__PURE__*/
function (_ExtendableError) {
  _inherits(APIError, _ExtendableError);

  function APIError() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$message = _ref.message,
        message = _ref$message === void 0 ? 'API error' : _ref$message,
        response = _ref.response,
        data = _ref.data,
        code = _ref.code;

    _classCallCheck(this, APIError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(APIError).call(this, message));
    _this.response = response;
    _this.data = data;
    _this.code = code;
    return _this;
  }

  return APIError;
}(ExtendableError);

exports.APIError = APIError;

var AuthError =
/*#__PURE__*/
function (_APIError) {
  _inherits(AuthError, _APIError);

  function AuthError() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref2$message = _ref2.message,
        message = _ref2$message === void 0 ? 'Authentication error' : _ref2$message,
        response = _ref2.response,
        data = _ref2.data,
        code = _ref2.code;

    _classCallCheck(this, AuthError);

    return _possibleConstructorReturn(this, _getPrototypeOf(AuthError).call(this, {
      message: message,
      response: response,
      data: data,
      code: code
    }));
  }

  return AuthError;
}(APIError);

exports.AuthError = AuthError;

var ClientNotSupportedError =
/*#__PURE__*/
function (_APIError2) {
  _inherits(ClientNotSupportedError, _APIError2);

  function ClientNotSupportedError() {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref3$message = _ref3.message,
        message = _ref3$message === void 0 ? 'Client not supported' : _ref3$message,
        response = _ref3.response,
        data = _ref3.data,
        code = _ref3.code;

    _classCallCheck(this, ClientNotSupportedError);

    return _possibleConstructorReturn(this, _getPrototypeOf(ClientNotSupportedError).call(this, {
      message: message,
      response: response,
      data: data,
      code: code
    }));
  }

  return ClientNotSupportedError;
}(APIError);

exports.ClientNotSupportedError = ClientNotSupportedError;